import { z } from 'zod'

export const featuresValidation = z
  .object({
    name: z
      .string()
      .min(1, { message: 'Feature Name must not be blank' })
      .max(50, { message: 'Feature Name must not be longer than 50 characters' }),
    desp: z
      .string()
      .max(255, { message: 'Description must not be longer than 255 characters' })
      .optional(),
    code: z
      .string()
      .min(1, { message: 'Code must not be blank' })
      .max(30, { message: 'Code must not be longer than 30 characters' }),
    remarks: z
      .string()
      .max(255, { message: 'Remarks must not be longer than 255 characters' })
      .optional(),
    type: z.string().min(1, { message: 'Must select a type' }),
    priviledges: z.string().optional(),
    productId: z.string().min(1, { message: 'Must select a product' }),
    defaultValue: z
      .string()
      .max(255, { message: 'Default Value must not be longer than 255 characters' })
      .optional(),
  })
  .refine(
    data => data.type !== 'P' || (data.priviledges && data.priviledges !== '' && data.priviledges !== undefined),
    {
      path: ['priviledges'], // Point the error to the privilegeIds field
      message: 'Must select at least 1 privilege if type is Privilege',
    },
  )

export type FeaturesValidation = z.infer<typeof featuresValidation>
